import AddressCell from '@/components/Reports/Cell/AddressCell.vue'

const config = {
  cellRenderer: AddressCell
}
export default {
  type: 'Address',
  config
}
